<div class="d-flex flex-column">
  <div class="l2-title">Symptoms</div>

  <ng-template #chosenSymptomsTemplate let-symptomsDescription="symptomsDescription">
    <div class="item-row mb-8px">
      <div class="item-label">Chosen Symptoms</div>
    </div>

    <div class="item-column my-8px">
      <div *ngFor="let symptom of symptomsDescription; let i = index" class="item-value d-flex my-4px">
        <dp-badge [color]="color.symptom[i + 1]" [size]="'wd-25px'" [text]="symptom.code"></dp-badge>
        <div class="badge-text ml-8px">{{ symptom.description }}</div>
      </div>
    </div>
  </ng-template>

  <!--
    <ng-container *ngIf="isDetail; else isEdit">
      <ng-container *ngTemplateOutlet="chosenSymptomsTemplate;context:selectedSymptom"></ng-container>
    </ng-container>
    <ng-template #isEdit>
    -->
  <div *ngIf="selectedSymptom?.type === 'hrm'" class="item-row mb-8px">
    <div class="item-label">Select Symptoms</div>
  </div>

  <ng-container *ngIf="!selectedSymptom; else isSelected">
    <div class="item-row mb-8px">
      <div class="item-desc">
        Please select a symptom that you’ve been experienced. If there is no symptom you find, please select ‘Others’
        symptom.
      </div>
    </div>

    <div class="item-row mb-8px">
      <div [ngClass]="{'simple-wrap': symptomList.type === 'dsr'}" class="symptom-wrapper w-100">
        <div (click)="selectSymptom(item, symptomList.type)"
             *ngFor="let item of symptomList.data" [ngClass]="{'not-found': !item.symptoms}"
             class="symptom-box my-8px simple">
          <span class="p-0">{{ item.name }}</span>
        </div>
        <ngx-spinner [fullScreen]="false" bdColor="rgba(255,255,255,0.8)" color="#000000" name="simpleSymptoms"
                     size="default" type="line-spin-clockwise-fade"></ngx-spinner>
      </div>
    </div>
  </ng-container>
  <ng-template #isSelected>

    <ng-template #symptomTemplate let-selectedSymptomName="name">
      <div class="symptom-wrapper">
        <div class="symptom-box my-8px wd-max">
          <span>{{ selectedSymptomName }}</span>
          <span (click)="cancelSymptom()"
                *ngIf="(isDetail && ([companies.Seca].includes(company) && this.basic.processType === 'ZR01') && isTicketEditable) || !isDetail"
                class="tab-close custom-close-w">
            <font-awesome [icon]="'fa-solid fa-xmark'"></font-awesome>
          </span>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="selectedSymptom?.type === 'hrm'; else isDsr">
      <div class="item-row">
        <ng-container *ngTemplateOutlet="symptomTemplate;context:selectedSymptom"></ng-container>
      </div>
    </ng-container>
    <ng-template #isDsr>
      <div class="item-row mb-8px">
        <div class="item-label">Simple Symptom</div>
        <div class="item-value">
          <ng-container *ngTemplateOutlet="symptomTemplate;context:selectedSymptom"></ng-container>
        </div>
      </div>
      <!--        <div class="item-row mb-8px" *ngIf="basic.serviceType === constants.serviceCode.IN_HOME">-->
      <!--          <div class="item-label">Description</div>-->
      <!--          <div class="item-value w-100">-->
      <!--            <textarea rows="5" [disabled]="viewResult()" [(ngModel)]="text"></textarea>-->
      <!--          </div>-->
      <!--        </div>-->
      <div *ngIf="sc4uInfo?.sc4uTarget && basic.serviceType === constants.serviceCode.IN_HOME && !viewResult()"
           class="item-row mb-8px justify-content-end">
        <button (click)="startDialog()" [disabled]="isDialog" class="btn btn-dark">Start Dialog</button>
      </div>
      <div class="item-row dialog-q mb-8px">
        <ng-container *ngFor="let dialog of dialogCommunications; let i = index; let first = first">
          <div class="dialog-result">
            <div class="dialog-a">{{ i + 1 }}. {{ dialog.question }}</div>
            <div *ngIf="dialog?.answer">
              <div class="symptom-wrapper">
                <div class="symptom-box my-8px wd-max">
                  <span>{{ dialog.answer.answer }}</span>
                  <span (click)="cancelDialog(i)" class="tab-close custom-close-w">
                    <font-awesome [icon]="'fa-solid fa-xmark'"></font-awesome>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!dialog?.answer" class="d-flex">
            <div (click)="selectDialog(item, i)"
                 *ngFor="let item of dialog.data;"
                 class="symptom-box dialog my-8px wd-max mr-8px">
              <span class="p-0">{{ item.answer }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-container *ngIf="viewResult()">
      <ng-container *ngTemplateOutlet="chosenSymptomsTemplate;context:selectedSymptom"></ng-container>
    </ng-container>
  </ng-template>
  <!--  </ng-template>-->

  <div class="ticket-horizontal-line"></div>
</div>
